import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useCareers from "store/careers/service-hook";
import DetailPageLayout from "../layouts/DetailPageLayout";

const SkillDetailPage = () => {
  const [skill, setSkill] = useState(null);
  const { fetchSkill } = useCareers();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;
    handleSetDetails();
  }, [id]);

  const handleSetDetails = async () => {
    setLoading(true);
    const res = await fetchSkill(id);
    setSkill(res);
    setLoading(false);
  };

  return (
    <DetailPageLayout
      loading={loading}
      data={skill}
      isSkill
      setData={setSkill}
    />
  );
};

export default SkillDetailPage;
